import { GoogleProductData } from 'types/GoogleProductData'
import { AppStoreData } from 'types/AppStoreData'

export const getGoogleProductData = ({ name, rating }: { name: string; rating: AppStoreData }): GoogleProductData => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: name,
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: rating.aggregateRating.ratingValue,
      ratingCount: rating.aggregateRating.ratingCount,
    },
  }
}
